module.exports = __webpack_public_path__ + "img/doruknet-logo.1c06c6c2.svg";